import FeatureHistoryListNavPaneContainer from './FeatureHistoryListNavPaneContainer'

export default FeatureHistoryListNavPaneContainer
